import { assignmentStore } from "../stores/assignment.store";
import { disclosureStore } from "../stores/disclosure.store";
import { entryDataStore } from "../stores/entry-data.store";
import { entryUIStore } from "../stores/entry-ui.store";
import { overviewStore } from "../stores/overview.store";
import { consolidatedStore } from "../stores/consolidated.store";
import { dataEntryFiltersStore } from "../stores/data-entry-filters.store";
import { prefillStore } from "../stores/prefill.store";
import { validationStore } from "../stores/validation.store";

export const useAssignmentStore = () => assignmentStore;
export const useDisclosureStore = () => disclosureStore;
export const useEntryDataStore = () => entryDataStore;
export const useEntryUIStore = () => entryUIStore;
export const useOverviewStore = () => overviewStore;
export const useConsolidatedStore = () => consolidatedStore;
export const useDataEntryFiltersStore = () => dataEntryFiltersStore;
export const usePrefillStore = () => prefillStore;
export const useValidationStore = () => validationStore;
